// @ts-expect-error Existing request helper is implemented in JS without typings.
import { request } from "./http";

interface PresignResponse {
  code: number;
  msg: string;
  data: {
    srcPath: string;
    newUrl: string;
  };
}

export const getPresignedUrl = async (srcPath: string): Promise<string> => {
  const response: PresignResponse = await request.post(
    "/api/v1/compute/file/handlerUrl",
    { srcPath }
  );
  return response.data.newUrl;
};